import type IDeviceStorage from 'lib/Interfaces/IDeviceStorage';

/**
 * Assigns device storage information from source template to target template.
 * except for the id and description fields.
 */
export const assignDeviceStorage = (target: IDeviceStorage, source: IDeviceStorage): IDeviceStorage => ({
  id: target.id,
  newStorage: source.newStorage,
  identifier: source.identifier,
  type: source.type,
  name: source.name,
  maxAgeSeconds: source.maxAgeSeconds,
  domain: source.domain,
  description: target.description ?? '',
});
